import type {
  GameState,
  UpdateSeatOrderAction,
  ValidationResult,
} from "../types";
import { validateHostAction, validateSetupPhase } from "./common";

export function validateUpdateSeatOrder(
  state: GameState,
  action: UpdateSeatOrderAction,
): ValidationResult {
  const hostCheck = validateHostAction(
    state,
    action.actorPlayerId,
    "Only host can edit seats",
  );
  if (!hostCheck.valid) return hostCheck;

  const phaseCheck = validateSetupPhase(state);
  if (!phaseCheck.valid) return phaseCheck;

  if (state.seatLocked) {
    return { valid: false, error: "Seat order is locked" };
  }

  if (action.seatOrder[0] !== state.hostPlayerId) {
    return { valid: false, error: "Host must remain seat 1" };
  }

  const expected = new Set(state.players.map((player) => player.id));
  const actual = new Set(action.seatOrder);
  if (
    actual.size !== expected.size ||
    action.seatOrder.length !== expected.size
  ) {
    return { valid: false, error: "Seat order must include each player once" };
  }
  for (const playerId of expected) {
    if (!actual.has(playerId)) {
      return {
        valid: false,
        error: "Seat order must include each player once",
      };
    }
  }

  return { valid: true };
}
